import { BlockStack, Box, Card, InlineGrid, Text } from "@shopify/polaris";

interface SectionProps {
  children: React.ReactNode;
  description?: string | undefined;
  title: string;
}

const Section = ({ children, description, title }: SectionProps) => {
  return (
    <div>
      <InlineGrid columns={{ md: "2fr 5fr", xs: "1fr" }} gap="400">
        <Box as="section" paddingInlineEnd={{ sm: "0", xs: "400" }} paddingInlineStart={{ sm: "0", xs: "400" }}>
          <BlockStack gap="200">
            <Text as="h3" variant="headingMd">
              {title}
            </Text>
            <Text as="p" variant="bodyMd">
              {description}
            </Text>
          </BlockStack>
        </Box>
        <BlockStack gap="300">{children}</BlockStack>
      </InlineGrid>
    </div>
  );
};

interface SettingsCardProps {
  children: React.ReactNode;
  description: string;
  title: string;
}

const SettingsCard = ({ children, description, title }: SettingsCardProps) => {
  return (
    <Card>
      <BlockStack gap="400">
        {(title || description) && (
          <BlockStack gap="100">
            {title && (
              <Text as="h3" variant="headingSm">
                {title}
              </Text>
            )}
            {description && (
              <Text as="p" tone="subdued">
                {description}
              </Text>
            )}
          </BlockStack>
        )}
        {children}
      </BlockStack>
    </Card>
  );
};

Section.Card = SettingsCard;
export default Section;
